module.exports = __webpack_public_path__ + "static/media/imagem-massa-inicial.873b19f1.svg";